import React from "react";
import { Loader2 } from "lucide-react";
import { slab } from "./faqConstants";

export const FaqLoadingState: React.FC = () => (
  <div className="flex flex-col items-center justify-center rounded-[1.75rem] border-4 border-white/10 bg-white/5 py-16">
    <Loader2
      className="h-12 w-12 animate-spin"
      style={{ color: slab.teal }}
      aria-label="Loading"
    />
    <p className="mt-4 font-extrabold text-white/70">Loading FAQ…</p>
  </div>
);
